module.exports = __webpack_public_path__ + "static/media/recover.7d8befd4.svg";